<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <div id="sr-route-announcement" aria-live="polite" aria-atomic="true" class="sr-only">{{ routeAnnouncement }}</div>
</ion-app>
